import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Card, Container, Row, Col, Button, Image } from "react-bootstrap";

//image
import image25 from "../../../assets/images/page-img/25.jpg";
import image26 from "../../../assets/images/page-img/26.jpg";
import image27 from "../../../assets/images/page-img/27.jpg";
import image28 from "../../../assets/images/page-img/28.jpg";
import { createCustomer, getPlan, handlePayment } from "../../../store/subscription/subscriptionThunk";
import axios from "axios";

//Pricing 2 page 
const Pricing1 = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [plans, setPlans] = useState([]);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const dispatch = useDispatch();
  const { createCustomerloading, createCustomerError, createCustomerFullfill,
    handlePaymentloading, handlePaymentError, handlePaymentFullfill,
    handleFatchPaymentLoading, handleFatchPaymentError, handleFatchPaymentFullfill,
    getPlanLoading, getPlanError, getPlanFullfill } = useSelector(
      (state) => state.subscription
    );




  useEffect(() => {
    // Fetch plans when the component mounts
    dispatch(getPlan());
  }, [dispatch]);

  useEffect(() => {
    setPlans(getPlanFullfill?.plans);
  }, [getPlanFullfill]);

  const handleClickPayment = async (item) => {
    try {
      alert(process.env.REACT_APP_RAZORPAY_ID_KEY)
      console.log(item, "itemitemitem")
      // Dispatch the createCustomer action and wait for the response
      const customerResponse = await dispatch(createCustomer()).unwrap();
      console.log(customerResponse, "customerResponse");

      // Now that we have the customer ID, we can handle the payment
      const response = await dispatch(handlePayment({ planId: item.razorpayPlanId, customerId: customerResponse.customerId })).unwrap();

      console.log(response, "response from handlePayment");

      if (response.status === 410) {
        alert("User already active");
        return;
      }

      const { subscriptionId, oneTimeChargeId, userId } = response;

      console.log(subscriptionId, oneTimeChargeId, userId, "subscriptionId, oneTimeChargeId, userId");

      // Proceed with Razorpay payment gateway integration
      const options = {
        key: process.env.REACT_APP_RAZORPAY_ID_KEY,
        subscription_id: subscriptionId,
        name: 'Initial Charge',
        description: 'Subscription Payment',
        handler: async function (paymentResponse) {
          await axios.post(`${BASE_URL}/plan/verify`, {
            razorpayPaymentId: paymentResponse.razorpay_payment_id,
            razorpaySubscriptionId: subscriptionId,
            razorpay_signature: paymentResponse.razorpay_signature,
            planId: item.razorpayPlanId,
            userId
          }).then(response => {
            alert('Payment successful and verified');
          }).catch(error => {
            alert('Payment verification failed');
          });
        },
        theme: {
          color: '#F37254'
        }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();

      setIsProcessingPayment(false);
    } catch (error) {
      console.error('Error during payment:', error);
      if (error?.status === 410) {
        alert("User already active");
      } else {
        alert('An error occurred, please try again.');
      }
      setIsProcessingPayment(false);
    }
  };

  return (
    <>
      <div id="content-page" className="content-inner">
        <Container>
          <Row>
            <Col sm="12">
              <Card
                className="position-relative inner-page-bg bg-primary"
                style={{ height: "150px" }}
              >
                <div className="inner-page-title">
                  <h3 className="text-white">Pricing 2</h3>
                  <p className="text-white">lorem ipsum</p>
                </div>
              </Card>
            </Col>
            {
              plans?.map((plan, i) =>
              (
                <Col lg="4" md="6" sm="12" key={i}>
                  <Card>
                    <Card.Body className="border text-center rounded">
                      <span className="text-uppercase">{plan.name}</span>
                      <div className="d-flex align-items-center justify-content-center">
                        <h2 className="mb-4 display-3">${plan.amount}</h2>
                        <small className=" text-muted">/ {plan.interval}</small>
                      </div>
                      <ul className="list-unstyled line-height-4 mb-0">
                        {plan.description}
                      </ul>
                      <Button className="btn-primary mt-5" onClick={() => handleClickPayment(plan)}>
                        Book consultation
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              )
              )
            }
            {/* <Col lg="3" md="6" sm="12">
              <Card className="bg-primary text-white">
                <Card.Body className="border text-center rounded">
                  <span className="text-uppercase">Basic</span>
                  <div className="d-flex align-items-center justify-content-center">
                    <h2 className="mb-4 display-3 text-white">$99</h2>
                    <small className="text-white-50">/ Month</small>
                  </div>
                  <ul className="list-unstyled line-height-4 mb-0 ">
                    <li>Lorem ipsum dolor sit amet</li>
                    <li>Consectetur adipiscing elit</li>
                    <li>Integer molestie lorem at massa</li>
                  </ul>
                  <button className="btn btn-light btn-block mt-5">
                    Start Starter
                  </button>
                </Card.Body>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="12">
              <Card>
                <Card.Body className="border text-center rounded">
                  <span className="text-uppercase">Basic</span>
                  <div className="d-flex align-items-center justify-content-center">
                    <h2 className="mb-4 display-3">$39</h2>
                    <small className=" text-muted">/ Month</small>
                  </div>
                  <ul className="list-unstyled line-height-4 mb-0">
                    <li>Lorem ipsum dolor sit amet</li>
                    <li>Consectetur adipiscing elit</li>
                    <li>Integer molestie lorem at massa</li>
                  </ul>
                  <Button className="btn-primary mt-5">Start Starter</Button>
                </Card.Body>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="12">
              <Card>
                <Card.Body className="border text-center rounded">
                  <span className="text-uppercase">Basic</span>
                  <div className="d-flex align-items-center justify-content-center">
                    <h2 className="mb-4 display-3">$25</h2>
                    <small className=" text-muted">/ Month</small>
                  </div>
                  <ul className="list-unstyled line-height-4 mb-0">
                    <li>Lorem ipsum dolor sit amet</li>
                    <li>Consectetur adipiscing elit</li>
                    <li>Integer molestie lorem at massa</li>
                  </ul>
                  <Button className="btn-primary mt-5">Start Starter</Button>
                </Card.Body>
              </Card>
            </Col>
            <Col lg="3">
              <Card className="bg-dark text-white text-center">
                <Image src={image25} className="card-img rounded" alt="#" />
                <div className="card-img-overlay">
                  <div className="d-flex align-items-center justify-content-center">
                    <h2 className="mb-4 display-3 text-white">$19</h2>
                    <small className="text-white">/ Month</small>
                  </div>
                  <ul className="list-unstyled line-height-4 mb-0 ">
                    <li>Lorem ipsum dolor sit amet</li>
                    <li>Consectetur adipiscing elit</li>
                    <li>Integer molestie lorem at massa</li>
                  </ul>
                  <Button className="btn-primary mt-3">Get started</Button>
                </div>
              </Card>
            </Col>
            <Col lg="3">
              <Card className="bg-dark text-white text-center">
                <Image src={image26} className="card-img rounded" alt="#" />
                <div className="card-img-overlay">
                  <div className="d-flex align-items-center justify-content-center">
                    <h2 className="mb-4 display-3 text-white">$19</h2>
                    <small className="text-white">/ Month</small>
                  </div>
                  <ul className="list-unstyled line-height-4 mb-0">
                    <li>Lorem ipsum dolor sit amet</li>
                    <li>Consectetur adipiscing elit</li>
                    <li>Integer molestie lorem at massa</li>
                  </ul>
                  <Button variant="primary" className="mt-3">
                    Get started
                  </Button>
                </div>
              </Card>
            </Col>
            <Col lg="3">
              <Card className="bg-dark text-white text-center">
                <Image src={image27} className="card-img rounded" alt="#" />
                <div className="card-img-overlay">
                  <div className="d-flex align-items-center justify-content-center">
                    <h2 className="mb-4 display-3 text-white">$19</h2>
                    <small className="text-white">/ Month</small>
                  </div>
                  <ul className="list-unstyled line-height-4 mb-0 ">
                    <li>Lorem ipsum dolor sit amet</li>
                    <li>Consectetur adipiscing elit</li>
                    <li>Integer molestie lorem at massa</li>
                  </ul>
                  <Button variant="primary" className="mt-3">
                    Get started
                  </Button>
                </div>
              </Card>
            </Col>
            <Col lg="3">
              <Card className="bg-dark text-white text-center">
                <Image src={image28} className="card-img rounded" alt="#" />
                <div className="card-img-overlay">
                  <div className="d-flex align-items-center justify-content-center">
                    <h2 className="mb-4 display-3 text-white">$19</h2>
                    <small className="text-white">/ Month</small>
                  </div>
                  <ul className="list-unstyled line-height-4 mb-0 ">
                    <li>Lorem ipsum dolor sit amet</li>
                    <li>Consectetur adipiscing elit</li>
                    <li>Integer molestie lorem at massa</li>
                  </ul>
                  <Button variant="primary" className="mt-3">
                    Get started
                  </Button>
                </div>
              </Card>
            </Col> */}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Pricing1;
